import { openContextModal } from "@mantine/modals";
import { exitFullscreen } from "@shared/lib/Utils.ts";

export const openTextCopyModal = (params: { text: string } & { onClose?: () => void }) => {
	const { onClose, ...innerProps } = params;

	void exitFullscreen();

	openContextModal({
		modal: "textCopyModal",
		innerProps: { text: params.text },
		withCloseButton: true,
		size: "lg"
		// styles: {
		// 	body: {
		// 		padding: "20px"
		// 	}
		// }
	});
};
